export default {
    //西班牙语
    DiagnosticReport:'Informe de diagnóstico',
    troubleCode:'Código de falla',
    time:'Tiempo',
    noTItle:'Control del fabricante',
    TestReport:'Informe de prueba',
    VehicleInformation:'Información del Vehículo',
    DataStream:'Flujo de datos',
    IMReadiness:'I/M Preparación',
    Communication:'Protocolo de comunicación',
    notFaultCode:'Sin Código de falla',
    nodataflow:'No hay flujo de datos anormal',
    // 语言
    lang:{
        cn:'Chino',
        de:'Alemán',
        en:'Inglés',
        es:'Español',
        fr:'Francés',
        it:'Italiano',
        ja:'Japonés',
        ko:'Coreano',
        pt:'Portugués'
    },
    PositioningPrompt:'Activa la función de localización para obtener los precios locales',
    FaultCode:'código de error',
    AIDiagnosis:'Diagnóstico por IA',
    AIWait:'Informe de IA o espera el diagnóstico automático',
    FailedFaultCode:'No se puede obtener información del código de falla',
    AIError:'Fallo en el análisis de IA',
    more:'más',
    StoredCodes:'Stored Codes',
    PendingCodes:'Pending Codes',
    PermanentCodes:'Permanent Codes',
    Unknown:'desconocido',
    ManufacturerControl:'Control del fabricante',
    continue:'Continuar',
    // 引导定位
    notlimits:'No se puede obtener el permiso de ubicación',
    setupSteps:'Pasos de configuración:',
    openset:'Abre la aplicación "Configuración"',
    findSet:'Encuentra la aplicación que estás usando',
    clickset:'Haz clic en "Ubicación"',
    selectLimits:'Selecciona "Durante el uso" o "Siempre"',
    blackRefresh:'Volver a la aplicación para actualizar la página',
    openAppSet:'Haz clic en "Gestión de aplicaciones" o "Aplicaciones"',
    findUseBrowser:'Encuentra el navegador que estás usando',
    clickAuthority:'Haz clic en "Gestión de permisos"',
    findejurisd:'Encontrar la permisión de "ubicación"',
    selectjurisd:'Selecciona "Permitir" o "Permitir durante el uso"',
    phoneJurisd:'Verificar los permisos de localización de la aplicación móvil:',
    openJurisd:'Activar el permiso "Ubicación"',
    report:'Informe',
    AI:'AI'
}